import Box from "@mui/material/Box"; // GLOBAL CUSTOM COMPONENTS

import { FlexBox } from "../flex-box";
import { Paragraph } from "../Typography"; // CUSTOM UTILS LIBRARY FUNCTIONS
import { calculateDiscount, formatMoney } from "src/lib/utils";

// ==============================================================
const ProductPrice = ({ price, discount = 0 }) => {
  return (
    <FlexBox alignItems="center" gap={1} mt={0.5}>
      <Paragraph fontWeight={600} color="primary.main">
        {formatMoney(price)}
      </Paragraph>

      {discount ? (
        <Box component="del" fontWeight={600} color="grey.600">
          {calculateDiscount(price, discount)}
        </Box>
      ) : null}
    </FlexBox>
  );
};

export default ProductPrice;
